function SentinelCheckInModal($rootScope, $timeout, sentinelService) {
    return {
        redirect: 'E',
        replace: true,
        scope: {
            visit: '=?'
        },
		template: require('./check-in-modal.html'),

        link: function (scope, element) {
            $timeout(function() {
                element.selectpicker();
            });

            scope.badgesRequired = false;

            scope.$watch(function () {
                return scope.visit;
            }, function (newVal) {
                if (newVal) {
                    sentinelService.getAccessPointsList($rootScope.selectedLog.id, scope.visit.facilityName).then(function(accessPoints) {
                        scope.availableAccessPoints = accessPoints;

                        if (scope.availableAccessPoints.length === 1) scope.selectedDoor = scope.availableAccessPoints[0]; // if only one door, use that for selectedDoor

                        sentinelService.getSelfCheckout($rootScope.selectedLog.id, scope.visit.facilityName).then(function(selfCheckout) {
                            if (selfCheckout) scope.escortIn = "Self"; // if self check-out is enabled, set escort-in to "Self".
                        });
                    });
                    sentinelService.getBadgesRequired($rootScope.selectedLog.id, scope.visit.facilityName).then(function(badgesRequired) {
                        scope.badgesRequired = badgesRequired === 'manual';
                    });
                }
            });

            scope.hideModal = function () {
                scope.doorIn = null;
                scope.escortIn = null;
                $rootScope.$broadcast('sentinel-hide-check-in-modal');
                $('#check-in-modal').modal('hide');
            };

            scope.checkInGuest = function () {
                scope.visit.doorIn = scope.selectedDoor;
                scope.visit.escortIn = scope.escortIn;
                if (scope.badgesRequired) { scope.visit.badgeCodeManual = document.getElementById('badgeId').value; }
                scope.visit.checkInTime = new Date();

                sentinelService.checkInGuest(scope.visit);

                this.hideModal();
            };
        }
    }
}

angular.module('sentinel').directive('sentinelCheckInModal', ['$rootScope', '$timeout', 'sentinelService', SentinelCheckInModal]);